import UserMenu from './UserMenu';

export default UserMenu;
